import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { styled, useTheme } from "@mui/material";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import clsx from "clsx";
import { useChatbotActions, useChatbotFilter } from "stores";
import Button from "components/ButtonCustom/ButtonNew";
import TextFieldCustom from "components/TextFieldCustom/TextFieldCustom";
import { Undo } from "@mui/icons-material";

const ActionsWrapper = styled("div")({
  margin: "0 10px 5px",
  "&.hidden": {
    visibility: "hidden",
    height: "50px",
  },
});

const TextFieldStyled = styled(TextFieldCustom)(({ theme }) => ({
  width: "100%",
  borderRadius: "8px",
  "& .input": {
    display: "none",
    outline: 0,
    "&.Mui-focused": {
      "& fieldset": {
        borderWidth: "1px",
        borderColor: theme.navbarColors.background,
      },
    },
  },
  "& .html-input": {
    height: "30px",
  },
  "&.visible": {
    "& .input": {
      display: "inherit",
      width: "100%",
    },
  },
}));

const ChatActionButtonGroup = styled("div")(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "end",
  gap: "0.5rem",
  paddingRight: "10px",
  "& .action-button": {
    color: theme.navbarColors.background,
  },
}));

const ChatbotTextInputUnstyled = ({
  placeholder,
  isVisible,
  className,
  onUndo,
  onReset,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const { filterOptions } = useChatbotActions();
  const { filterInput, isFilterInputDisabled, isUndoEnabled } =
    useChatbotFilter();

  const handleChange = useCallback(
    (e) => {
      const value = e.target.value;
      filterOptions(value);
    },
    [filterOptions]
  );

  return (
    <ActionsWrapper className={clsx(className, { hidden: !isVisible })}>
      <ChatActionButtonGroup>
        {isUndoEnabled && (
          <>
            <Button className="action-button" variant="text" onClick={onUndo}>
              <Undo />
              {t("Chatbot.UndoButton")}
            </Button>
            <Button className="action-button" variant="text" onClick={onReset}>
              <RestartAltIcon />
              {t("Chatbot.RestartButton")}
            </Button>
          </>
        )}
      </ChatActionButtonGroup>
      <TextFieldStyled
        value={filterInput}
        placeholder={placeholder}
        isDisabled={isFilterInputDisabled}
        color={theme.navbarColors.background}
        className={clsx("text-input", { visible: isVisible })}
        onChange={handleChange}
      />
    </ActionsWrapper>
  );
};

const ChatbotTextInput = styled(ChatbotTextInputUnstyled)({});

export default ChatbotTextInput;
